export default "__VITE_ASSET__CYRLBsD3__"